export const osStandardFilterFields = [
	'usageId',
	'organizationId',
	'usageName',
	'takeoffTypeId',
	// 'wastage', //TODO: enable when needed
	// 'wastagePercentage', //TODO: enable when needed
] as const;
export const osDateFilterFields = ['createdAt', 'updatedAt'] as const;

export const filterFields = [...osStandardFilterFields, ...osDateFilterFields] as const;
